module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_m_leucistic.1050a2a7.png";